<template>
  <main class="grid-container overflow-visible">
    <Head title="Búsqueda" />
    <!-- Home Search Section -->
    <section class="grid-container col-span-full px-0 justify-center items-center py-4 surface1">
      <div class="flex flex-col gap-1 p-2">
        <h1
          class="text-brand-bright-green font-extrabold text-center display-sm md:leading-[44px] md:tracking-tighter"
        >
          ¡Encuentra las mejores ofertas de trabajo!
        </h1>
      </div>
      <SearchBar :locations="search_locations" :query-params="transformed_query_params" />
    </section>
    <!-- / End Home Search Section -->
    <!-- Search results section -->
    <section class="py-2">
      <h2 class="headline-sm text-tertiary60 py-4">Resultados de la búsqueda</h2>
      <div
        v-if="query_results.length > 0"
        class="flex flex-col gap-4 select-none sm:flex-row sm:flex-wrap sm:gap-x-0"
      >
        <Link
          v-for="(offer, key) in query_results"
          :key="key"
          :href="$route('jobposting', offer.id)"
          class="sm:w-1/3 px-2"
        >
          <OfferCard :offer="offer" class="min-w-[250px] sm:w-full" with-button show-company />
        </Link>
      </div>
      <Alert v-else class="!p-4">
        No se encontraron coincidencias
      </Alert>
    </section>
    <!-- / End Search results section -->
  </main>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue'
import Layout from '@/Layouts/Layout'
import SearchBar from '@/Components/SearchBar'

export default {
  name: 'Search',
  layout: Layout,
  components: {
    Link,
    Head,
    SearchBar,
    OfferCard: () => import('@/Components/OfferCard'),
    Alert: () => import('@/Components/Alert'),
  },
  props: {
    query_params: Object,
    query_results: {
      type: Array,
      required: false,
      default: [],
    },
    search_locations: {
      type: Array,
      required: false,
      default: [],
    },
  },
  computed: {
    transformed_query_params() {
      const defaultParams = { query: '', location: '' }
      return this.query_params ? { ...defaultParams, ...this.query_params } : defaultParams
    },
  },
}
</script>
